import React from "react";
import { BrowserView, MobileView } from "react-device-detect";
import DesktopModalLayout from "src/bepaid/components/Modal/components/DesktopModalLayout";
import { FetchModalID } from "src/ipm-shared/components/GlobalUI/actions";

import PersonalInformation from "src/bepaid/layouts/Menu/components/PersonalInformation";
import MainLayout from "src/bepaid/layouts/MainLayout";

import styles from "./Personal.module.scss";

const View = (props: any) => {
  const toggleModal = () => {
    props.toggleModal(FetchModalID.UPDATE_PERSONAL_INFO);
  };

  const onSaved = () => {
    toggleModal();
  };

  const renderContent = () => (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <PersonalInformation onSaved={onSaved} />
      </div>
    </div>
  );

  return (
    <>
      <BrowserView>
        <DesktopModalLayout
          title={"Personal information"}
          onClose={toggleModal}
        >
          {renderContent()}
        </DesktopModalLayout>
      </BrowserView>
      <MobileView>
        <MainLayout
          header={{
            title: "Personal information",
            hideMenu: true,
            onClose: toggleModal
          }}
        >
          {renderContent()}
        </MainLayout>
      </MobileView>
    </>
  );
};

export default View;
